/** A URL-safe fallback slug base for a new artist, before the random suffix that avoids collisions. */
export function slugifyArtistName(name: string): string {
  const slug = name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  return slug === '' ? 'artist' : slug;
}
